import { Box, Typography } from '@mui/material';

import { practiceSettingsSubtitleSx, practiceSettingsTitleSx } from './practiceSettingsTypography';

export function PracticeSettingsHeading({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography component="h1" sx={practiceSettingsTitleSx}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" sx={practiceSettingsSubtitleSx}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
